

/*
 *---------------------------------------------------
 * Licensed Materials - Property of HCL Technologies
 *
 * HCL Commerce
 *
 * (C) Copyright HCL Technologies Limited 2021
 *
 *---------------------------------------------------
 */
import React, { createContext, useContext, useState } from "react";
//custom libraries
import { initParams, ParamsJson } from "../hooks/use-order-form";

export const ParamsContext: React.Context<any> = createContext(null);
export const ParamsProvider = ({ children }: any) => {
  const [params, setParams] = useState<ParamsJson | any>(initParams);

  return (
    <ParamsContext.Provider value={{ params, setParams }}>
      {children}
    </ParamsContext.Provider>
  );
};

export const useParamsValue = () => useContext(ParamsContext);
